(function () {
  const selectAll = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const selectOne = (selector, root = document) => root.querySelector(selector);

  const getScopedVariant = (event, productInfo) => {
    const variant = event?.detail?.variant || event?.detail?.selectedVariant || null;
    if (!productInfo) return variant;

    const eventSection = event?.target?.closest?.('[id^="shopify-section-"]');
    const productSection = productInfo.closest('[id^="shopify-section-"]');

    if (eventSection && productSection && eventSection !== productSection) {
      return null;
    }

    return variant;
  };

  const initProductInfo = (productInfo) => {
    if (!productInfo || productInfo.dataset.mediaGuardianReady === 'true') return;
    productInfo.dataset.mediaGuardianReady = 'true';

    const fallbackMediaId = productInfo.dataset.productFallbackMediaId || '';
    const mediaItems = () => selectAll('.product__media-item, [id^="Media-"]', productInfo);
    const thumbs = () => selectAll('.thumbnail, .thumbnail-list__item button, [data-media-id]', productInfo);

    const selectByMediaId = (id) => {
      if (!id) return false;

      const pick =
        selectOne(`.thumbnail[aria-controls="Media-${id}"]`, productInfo) ||
        selectOne(`.thumbnail [aria-controls="Media-${id}"]`, productInfo) ||
        selectOne(`[data-media-id="Media-${id}"]`, productInfo) ||
        selectOne(`#Media-${id}`, productInfo);

      if (!pick) return false;
      (pick.closest('button, .thumbnail') || pick).click?.();
      return true;
    };

    const ensureOneVisible = () => {
      const visible = mediaItems().filter((element) => {
        const styles = getComputedStyle(element);
        return styles.display !== 'none' && styles.visibility !== 'hidden';
      });

      if (visible.length) return visible[0];

      mediaItems().forEach((element) => element.style.removeProperty('display'));

      const first = mediaItems()[0];
      if (first) {
        const img = first.querySelector('img');
        if (img) img.loading = 'eager';
      }

      return first || null;
    };

    const selectSafe = (variant) => {
      const variantMediaId = variant?.featured_media?.id;

      if (selectByMediaId(variantMediaId)) return true;
      if (selectByMediaId(fallbackMediaId)) return true;

      const first = ensureOneVisible();
      const firstThumb =
        thumbs().find((thumb) => {
          const styles = getComputedStyle(thumb);
          return styles.display !== 'none' && styles.visibility !== 'hidden';
        }) || thumbs()[0];

      if (firstThumb) {
        (firstThumb.closest('button, .thumbnail') || firstThumb).click?.();
        return true;
      }

      return !!first;
    };

    const scheduleSafeSelect = (variant) => {
      requestAnimationFrame(() => selectSafe(variant));
      setTimeout(() => selectSafe(variant), 0);
      setTimeout(() => selectSafe(variant), 250);
    };

    const startGuardian = () => {
      const list = selectOne('.product__media-list', productInfo) || productInfo;
      if (!list) return;

      const fixIfBlank = () => {
        const active =
          selectOne(
            '.product__media-item.is-active, .product__media-item.is-selected, .product__media-item.__mobile-visible',
            productInfo
          ) || mediaItems()[0];

        const img = active && active.querySelector('img');
        const blank =
          !active ||
          getComputedStyle(active).display === 'none' ||
          (img && !(img.currentSrc || img.src));

        if (blank) {
          scheduleSafeSelect(window.__lastSelectedVariant || null);
        }
      };

      /* Disabled the observer to avoid breaking the manual slide and thumbnail clicking
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            fixIfBlank();
            break;
          }
        }
      });

      observer.observe(list, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'src'],
      });
      */

      window.addEventListener('load', fixIfBlank, { once: true });
      window.addEventListener('resize', () => setTimeout(fixIfBlank, 0));
    };

    const onVariant = (event) => {
      const variant = getScopedVariant(event, productInfo);
      if (event && !variant) return;

      window.__lastSelectedVariant = variant || window.__lastSelectedVariant || null;
      scheduleSafeSelect(variant);
    };

    document.addEventListener('variant:change', onVariant);
    document.addEventListener('variant:changed', onVariant);
    document.addEventListener('product:variant-change', onVariant);

    scheduleSafeSelect(window.__lastSelectedVariant || null);
    startGuardian();
  };

  const initAll = () => {
    document.querySelectorAll('product-info.product-info--pdp').forEach(initProductInfo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
